// Module
var code = `<div class="col-lg-12">
    <bfg-chart name="retention.NewDevicesChart"></bfg-chart>
</div>
`;
// Exports
module.exports = code;